import { Flex, Icon, Text, chakra } from "@chakra-ui/react";
import { FiFileText } from "react-icons/fi";

// Scanned documents have no answers to lay out: show the uploaded file itself.

interface Props {
  pdfUrl: string | null;
  title: string;
}

export default function ScannedDocumentView(props: Props) {
  if (props.pdfUrl === null) {
    return (
      <Flex align="center" direction="column" gap={2} h="full" justify="center" py={16}>
        <Icon as={FiFileText} boxSize={8} color="gray.300" />
        <Text color="gray.600" fontWeight="medium">
          No file available
        </Text>
        <Text color="gray.500" fontSize="sm">
          This scanned document has no file attached.
        </Text>
      </Flex>
    );
  }

  return (
    <chakra.iframe
      bg="white"
      border="none"
      display="block"
      h="full"
      src={props.pdfUrl}
      title={props.title}
      w="full"
    />
  );
}
